import data from './data'

export default {
  data,
  resourcePath: '/v1/professional/settings/policy'
}



// WEBPACK FOOTER //
// ./src/app/professional/privacy-policy/index/resources/index.js